import BigNumber from 'bignumber.js'
import React, {useState,useEffect,useCallback} from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { Heading, Spinner } from '@pancakeswap-libs/uikit'
import Input from 'components/Input'
import FlexLayout from 'components/layout/Flex'
import Pagination from 'components/layout/Pagination'
import { getTokenAddressFromQuery } from 'utils/sep20FactoryUtils'
import { useSingleSep20Token } from '../hooks/useSep20Factory'
import Sep20Card from './Sep20Card'


const InputContainer = styled.div`
  text-align: center;
  position: relative;
`;

const InputWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 500px;
  padding-bottom: 30px;

  @media (max-width: 600px) {
    width: 100%;
  }
`

const StyledFont = styled.div`
  font-family: 'Verdana',sans-serif;
`

const Devider = styled.div`
  background-color: ${({ theme }) => theme.colors.textSubtle};
  height: 1px;
  margin: 0 auto 10px;
  width: 100%;
`;

const SearchResultContainer = styled(FlexLayout)`
  padding: 15px 0;
`

const RecentContainer = styled(FlexLayout)`
  padding-top: 20px;
`

const SpinnerOuterContainer = styled.div`
  padding: 10px;
  text-align: center;
`
const SpinnerInnerContainer = styled.span`
  display: inline-block;
  position: relative;
  width: 64px;
`

export interface ExplorerProps {
    tokens: any
    account?: string
    setPage: any
}

const Explorer: React.FC<ExplorerProps> = ({ tokens, account, setPage  }) => {
  const TranslateString = useI18n();
  const [address, setAddress] = useState(getTokenAddressFromQuery() || "");
  const [tokenAddress, setTokenAddress] = useState(Web3.utils.isAddress(getTokenAddressFromQuery())?getTokenAddressFromQuery():"");
  const { currentPage, pageCount, count } = tokens;

  const searchResult = useSingleSep20Token(tokenAddress);

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setAddress(value);
    if (Web3.utils.isAddress(value)) {
      setTokenAddress(value);
    } else {
      setTokenAddress("");
    }
  };

  const renderList = (list) => {
    return list.map((token) => (
      <Sep20Card
          key={`recentsep20token_${token.address}`}
          token = {token}
          account = {account}
      />
    ))
  };

  const [shouldShowSpinner, setShouldShowSpinner] = useState(false);

  useEffect(() => {
    setShouldShowSpinner(false);
  }, [account, currentPage])

  const onPaginationClick = (newPage) => {
    setShouldShowSpinner(true);
    setPage(newPage);
  }

  const showingSpinner = shouldShowSpinner || !tokens || !tokens.tokens || !tokens.tokens.length;

  return (
    <>
        <InputContainer>
          <InputWrapper>
            <div>
              <Input
                  onChange={handleChange}
                  placeholder={TranslateString(170,"Token Address")}
                  value={address}
              />
            </div>
          </InputWrapper>
        </InputContainer>
        {
          tokenAddress && searchResult && searchResult.length && searchResult[0] && (
            <SearchResultContainer>
              <Sep20Card
                  token = {searchResult[0]}
                  account = {account}
              />
            </SearchResultContainer>
          ) || ""
        }
        <Heading as="h1" size="lg" color="textSubtle" mb="30px" mt="30px" style={{ textAlign: 'center'}}>
            <StyledFont>
            {TranslateString(417,'History')} {count?`(${TranslateString(519,'Total')}: ${count})`:``}
            </StyledFont>
        </Heading>
        <Devider />
        {
          showingSpinner ? (
            <SpinnerOuterContainer><SpinnerInnerContainer><Spinner/></SpinnerInnerContainer></SpinnerOuterContainer>
          ) : (
            <div>
              <RecentContainer>
                  {renderList(tokens.tokens || [])}
              </RecentContainer>
              {
                pageCount > 1 ? (
                  <Pagination onClick={onPaginationClick} name="historysep20tokens" current={currentPage} count={pageCount} />
                ): ""
              }
            </div>
          )
        }
    </>
  )
}

export default Explorer
